// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// mock
// import mock from '../mock/index.js'
// Vue.use(mock);

import { VueJsonp } from 'vue-jsonp'    // 网上很多博客引用不加{}，会报错
Vue.use(VueJsonp)

import { message } from './assets/resetMessage'
Vue.prototype.$message = message;

// 引用API文件
import api from './api/index'   //切换环境js
// 将API方法绑定到全局
Vue.prototype.$api = api

// 读取本地json语言包
const LANGUAGES = {
  chs: require('./assets/message/zh-CN.json'),
  // en: require('../../assets/languages/en.json')
}

// 图片懒加载
import VueLazyload from 'vue-lazyload'
 
Vue.use(VueLazyload, {
  preLoad: 1.3, //预加载高度
  error: require('../static/images/loading.gif'), //错误展示图片
  loading: require('../static/images/loading.gif'), //加载等待图片
  attempt: 1 //尝试次数
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  // template: '<App :LANGUAGES ="LANGUAGES"/>',
  // data:{
  //   LANGUAGES:LANGUAGES['chs'] // chs这个值，根据项目情况动态获取
  // }
})



// WEBPACK FOOTER //
// ./src/main.js